import { useCallback, useContext, useState } from "react";
import { buildFcmPayload } from "global/functions/fbNotifications";
import { _developerFcm } from "project/appConfiguration";
import { useFunctions } from "./useFunctions";

export const _fcmTopicKeys = {
  generic: 'XIbIQe4rhWJn5qDRBnI4',
  error: 'me_app_error',
  auth: 'me_app_auth',
}

export const useFcmSubscribe = () => {

  const { fn_cls } = useFunctions()

  const [subscribeResponse, setSubscribeResponse] = useState()

  const cb = (result, fcmPayload) => { setSubscribeResponse({ result, fcmPayload }) }

  const handleSubscribe_toTopic = useCallback((token, topicKey, unsubscribe, itemKey) => {
    console.log('handleSubscribe_toTopic')
    fn_cls.subscribeToTopic(token, topicKey, unsubscribe, itemKey, cb)
  }, []);

  // const handleSubscribe = useCallback((tokenKey, title, body) => {
  //   const _payload = buildFcmPayload([tokenKey], _fcmTopicKeys.error, title, body)
  //   fn_cls && fn_cls.sendFcmPayload(_payload, null, cb)
  // }, []);

  return {
    subscribeResponse,
    handleSubscribe_toTopic,
    // handleSubscribe,
  };
};
